import StellarSdk from 'stellar-sdk';

const stellarMainNet = new StellarSdk.Server('https://horizon.stellar.org');
const stellarTestNet = new StellarSdk.Server(
  'https://horizon-testnet.stellar.org/'
);
const stellarStrKey = StellarSdk.StrKey;

export { stellarMainNet, stellarTestNet, stellarStrKey };
